var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrello(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_1_);}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 538.6754,
    y1: 625.7023,
    x2: 538.6754,
    y2: 531.3626,
    gradientTransform: "matrix(0.53 0 0 0.53 -220.498 -261.449)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#0052CC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2684FF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.8,20H46.4c-3.4,0-6.3,2.7-6.3,6.2c0,0,0,0.1,0,0.1v37.5c0,3.4,2.8,6.2,6.2,6.2c0,0,0,0,0,0h37.4 c3.4,0,6.2-2.8,6.2-6.2V26.3C90,22.9,87.2,20.1,83.8,20z M61.8,57.9c0,1.7-1.3,3-3,3h-9.2c-1.7,0-3-1.3-3-3V29.5c0-1.7,1.3-3,3-3 h9.3c1.7,0,3,1.3,3,3l0,0L61.8,57.9z M83.6,45.4c0,1.7-1.3,3-3,3h-9.3c-1.7,0-3-1.3-3-3V29.5c0-1.7,1.3-3,3-3h9.3c1.7,0,3,1.3,3,3 L83.6,45.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrello);
export default __webpack_public_path__ + "static/media/Trello.ecb21c0510f583b6490e14bdd8821235.svg";
export { ForwardRef as ReactComponent };